var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var defaultState = {
    headsignRoute: '',
    headsignText: '',
    nextStop: null,
    _tripStops: [],
    upcomingStops: [],
    atStop: false,
};
export function displaysReducer(state, action) {
    if (state === void 0) { state = defaultState; }
    switch (action.type) {
        case 'UPDATE_RECEIVED':
            if (action.message.type === 'tripStatus') {
                var payload_1 = action.message.payload;
                var nextStop = state._tripStops && state._tripStops.find(function (s) { return s.stopSequence === payload_1.stopSequence; });
                return __assign({}, state, { headsignRoute: payload_1.headsignRoute, headsignText: payload_1.headsignText, nextStop: nextStop && nextStop.stopName || '', upcomingStops: state._tripStops &&
                        state._tripStops.filter(function (s) { return s.stopSequence >= (payload_1.stopSequence || 0); }).map(function (s) { return s.stopName; }), atStop: payload_1.atStop });
            }
            else if (action.message.type === 'tripSelection') {
                return __assign({}, state, { _tripStops: action.message.payload.stops, upcomingStops: action.message.payload.stops.map(function (s) { return s.stopName; }) });
            }
    }
    return state;
}



//////////////////
// WEBPACK FOOTER
// ./src/components/Displays/reducers.ts
// module id = 1829
// module chunks = 0